import i18n from 'i18next';
import { Steps } from '../../../../../BaseComponents/Stepbar/types';
import { capitalizeFirstLetter } from '../../../../../utils';
import { useSteps } from '../../../utils';
import { CheckinStep } from '../../../types';
import { CheckoutSteps } from '../../../../../MobileStepbar/types';
import { SelectedSeatFragment } from '@websky/graphql';

export const useStepsToStepbarStepsAdapter = (steps: CheckinStep[]): Steps => {
	const { setStep } = useSteps();

	const stebBarSteps: Steps = {};
	steps.forEach(step => {
		stebBarSteps[step] = {
			label:
				step === CheckinStep.Passengers
					? i18n.t('Checkin:Passengers')
					: i18n.t(`Checkin:${capitalizeFirstLetter(step)}`),
			onClick: () => setStep(step),
			type: step
		};
	});
	stebBarSteps['boardingPass'] = {
		label: i18n.t('Checkin:Boarding pass'),
		type: CheckoutSteps.BoardingPass
	};

	return stebBarSteps;
};

export const useGetGoBack = (currentStep: CheckinStep) => {
	const { getPreviousStepEnum, previousStep } = useSteps();

	return getPreviousStepEnum(currentStep) !== CheckinStep.Passengers ? () => previousStep(currentStep) : undefined;
};

export const groupSeatsBySegment = (seats: SelectedSeatFragment[]): SelectedSeatFragment[][] => {
	const grouped: { [key: string]: SelectedSeatFragment[] } = {};

	for (const seat of seats) {
		const segmentId = seat.segment?.id ?? 'undefined';
		if (!grouped[segmentId]) {
			grouped[segmentId] = [];
		}
		grouped[segmentId].push(seat);
	}

	return Object.values(grouped);
};
